import Rails from '@rails/ujs';
import { ref } from 'vue';
import api from './index';

const DEFAULT_PRODUCTS_PER_PAGE = 24;
const token = ref(Rails.csrfToken());
let headers = {};
if (token.value) {
  headers = { 'X-CSRF-Token': token.value };
}

export default {
  index(page = 1, perPage = DEFAULT_PRODUCTS_PER_PAGE) {
    const path = `/api/internal/product_likes?page[number]=${page}&page[size]=${perPage}`;

    return api({
      method: 'get',
      url: path,
      headers,
    });
  },

  create(productId: number) {
    const path = '/api/internal/product_likes';
    const data = { product_like: { product_id: productId } };

    return api({
      method: 'post',
      url: path,
      data,
      headers,
    });
  },

  delete(productId: number) {
    const path = '/api/internal/product_likes/';
    const data = { product_like: { product_id: productId } };

    return api({
      method: 'delete',
      url: path,
      data,
      headers,
    });
  },
};
